import axios from 'axios';
import _ from 'lodash';
import { GetEvents } from '../modelProfile/actions';
import {
	ADD_MODELS_SUCCESS,
	DELETE_MODELS_SUCCESS,
	DEVICE_MODEL_STATUS,
	EDIT_MODELS_SUCCESS,
	FETCH_BRANDS,
	FETCH_COMMANDS_TYPES,
	FETCH_DEVICE_MODELS,
	FETCH_DEVICE_MODELS_COUNT,
	FETCH_MODEL_SEND_TYPES,
} from './actionTypes';

export const InitModelView = () => async (dispatch) => {
	try {
		await dispatch(GetBrands());
		await dispatch(GetModelSendType());
		await dispatch(GetEvents());
		return await dispatch(GetCommandType());
	} catch (error) {
		return error;
	}
};

export const GetDeviceModels =
	(page = 1, pageSize = 15, where = {}, cancelTocken) =>
	(dispatch) => {
		let filter = {
			limit: pageSize,
			skip: (page - 1) * pageSize,
			include: ['modelSendType', 'brand', 'eventModel', 'commands'],
			where: {
				...where,
			},
			order: 'description ASC',
		};

		return axios
			.get(`/DeviceModels/?filter=${encodeURIComponent(JSON.stringify(filter))}`, {}, cancelTocken)
			.then((response) => {
				dispatch({
					type: FETCH_DEVICE_MODELS,
					deviceModels: response.data,
				});
				return response.data;
			});
	};

export const GetDeviceModelsCount =
	(where = {}) =>
	(dispatch) => {
		return axios.get(`/DeviceModels/count?where=${encodeURIComponent(JSON.stringify(where))}`).then((response) => {
			dispatch({
				type: FETCH_DEVICE_MODELS_COUNT,
				count: response.data.count,
			});
		});
	};

export const SearchModels =
	(search = '', page = 1, pageSize = 15, cancelTocken) =>
	(dispatch) => {
		search = search.trim();
		let regx = '%' + search + '%';

		let filter = {
			limit: pageSize,
			skip: (page - 1) * pageSize,
			include: ['modelSendType', 'brand', 'eventModel', 'commands'],
			where: {},
			order: 'description ASC',
		};

		if (search.length > 0) {
			filter.where = {
				or: [{ description: { like: regx } }],
			};
		}

		return dispatch(GetDeviceModelsCount(filter.where)).then(() => {
			return dispatch(GetDeviceModels(page, pageSize, filter.where, cancelTocken));
		});
	};

export const DeleteModels = (ids) => (dispatch) => {
	let options = { data: { ids: ids } };

	return axios.delete(`/DeviceModels`, options).then((response) => {
		dispatch({ type: DELETE_MODELS_SUCCESS });
		dispatch(SearchModels(''));
		return response.data;
	});
};

const addDeviceModels = (deviceModels, models) => {
	let allModels = _.cloneDeepWith(models);
	if (allModels.length > 9) allModels.pop();
	return {
		type: ADD_MODELS_SUCCESS,
		deviceModels: [deviceModels, ...allModels],
	};
};

export const AddDeviceModels =
	({ description, modelSendTypeId, brandId, events, commands }) =>
	(dispatch, getState) => {
		let state = getState();
		let data = {
			model: {
				active: true,
				description,
				modelSendTypeId,
				brandId,
				events,
				commands,
			},
		};

		return axios.post('/DeviceModels/save', data).then((response) => {
			let models = state.deviceModel.deviceModels;
			return dispatch(addDeviceModels(response.data, models));
		});
	};

const editDeviceModels = (deviceModels, models) => {
	return {
		type: EDIT_MODELS_SUCCESS,
		deviceModels: models.map((mod) => {
			if (mod.id === deviceModels.id) return deviceModels;
			return mod;
		}),
	};
};

export const EditModels =
	({ id, description, modelSendTypeId, brandId, events, commands }) =>
	(dispatch, getState) => {
		let state = getState();
		let models = state.deviceModel.deviceModels;
		let data = {
			model: {
				active: true,
				description,
				modelSendTypeId,
				brandId,
				events,
				commands,
			},
			oldModel: models.filter((model) => id === model.id)[0],
		};

		return axios.patch(`/DeviceModels/${id}/save`, data).then((response) => {
			dispatch(editDeviceModels(response.data, models));
		});
	};

export const DisableModels = (id, active) => (dispatch) => {
	let data = { active: !active };

	return axios.patch(`/DeviceModels/${id}`, data).then(() => {
		dispatch({ type: DEVICE_MODEL_STATUS, id });
	});
};

export const GetBrands = () => (dispatch) => {
	return axios.get('/Brands').then((response) => {
		dispatch({ type: FETCH_BRANDS, brands: response.data });
	});
};

export const GetModelSendType = () => (dispatch) => {
	return axios.get('/ModelSendTypes').then((response) => {
		dispatch({
			type: FETCH_MODEL_SEND_TYPES,
			modelSendTypes: response.data,
		});
	});
};

export const GetCommandType = () => (dispatch) => {
	return axios.get('/CommandTypes').then((response) => {
		dispatch({ type: FETCH_COMMANDS_TYPES, commandTypes: response.data });
	});
};
